import { useSelector } from 'react-redux'
import { UserExperienceSensorModeKind } from '@src/types'
import { uxSensorModeKindSelector } from '@src/selectors/app'
import { OWN_SENSOR_MODES } from './types'

export const isByosOnboardingSensorMode = (
  sensorModeKind: UserExperienceSensorModeKind | undefined,
) => {
  if (!sensorModeKind) {
    return false
  }

  return OWN_SENSOR_MODES.includes(sensorModeKind)
}

export const useIsHealthPermissionRequired = () => {
  const uxSensorModeKind = useSelector(uxSensorModeKindSelector)

  if (!uxSensorModeKind) {
    return false
  }

  return [
    UserExperienceSensorModeKind.Lingo,
    UserExperienceSensorModeKind.OwnSensorLibre1,
    UserExperienceSensorModeKind.OwnSensorLibre2,
    UserExperienceSensorModeKind.OwnSensorLibre3,
  ].includes(uxSensorModeKind)
}
